import React, { useState, useEffect, useContext } from 'react';
import './CredentialForm.css';
import Navbar from '../../../Shared/Navbar/Navbar';
import { baseURL } from '../../../Apiservices/Api';
import { ThemeContext } from '../../../Shared/Themes/ThemeContext';
import { useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';
import { Eye, EyeSlash } from 'react-bootstrap-icons';

const CredentialForm = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const { themeColor } = useContext(ThemeContext);
  const { id } = useParams(); // 👈 Used for editing
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    sender_email: '',
    app_password: '',
  });

  // Fetch data if editing
  useEffect(() => {
    if (id) {
      const fetchCredential = async () => {
        try {
          const res = await fetch(`${baseURL}/api/getcredentials/${id}`);
          const data = await res.json();
          setFormData({
            sender_email: data.sender_email || '',
            app_password: data.app_password || '',
          });
        } catch (error) {
          console.error('Error fetching credential:', error);
        }
      };
      fetchCredential();
    }
  }, [id]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e, mode = 'save') => {
    e.preventDefault();
    setLoading(true);

    try {
      const method = id ? 'PUT' : 'POST';
      const url = id
        ? `${baseURL}/api/getcredentials/${id}`
        : `${baseURL}/api/credentials`;

      const response = await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log(result);

      alert(`Credential ${id ? 'updated' : 'saved'} successfully!`);

      if (mode === 'saveAndClose') {
        navigate(-1);
      } else if (!id) {
        setFormData({ sender_email: '', app_password: '' });
      }

    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit credential!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesViewLeads ${collapsed ? 'collapsed' : ''}`}>
        <div className="credential-form">
          <h2 className="credential-header">
            {id ? 'Edit Credential' : 'Add Credential'}
          </h2>

          <form onSubmit={handleSubmit} className="credential-form-grid">
            <div className="credential-input-group full-width">
              <label>Sender Email:</label>
              <input
                type="email"
                name="sender_email"
                value={formData.sender_email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="credential-input-group full-width password-field">
              <label>App Password:</label>
              <div className="cred-password-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="app_password"
                  value={formData.app_password}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="cred-toggle-password-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ color: themeColor }}
                >
                  {showPassword ? <EyeSlash /> : <Eye />}
                </button>
              </div>
            </div>


            <div className="credential-form-footer ">
              <Button variant="secondary" onClick={() => navigate(-1)}>
                Back
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={loading}
                style={{
                  backgroundColor: themeColor,
                  borderColor: themeColor,
                }}
              >
                {loading ? 'Saving...' : id ? 'Update' : 'Save'}
              </Button>
              <Button
                variant="success"
                type="button"
                onClick={(e) => handleSubmit(e, 'saveAndClose')}
                disabled={loading}
              >
                {loading ? 'Saving...' : id ? 'Update & Close' : 'Save & Close'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CredentialForm;
